module.exports = __webpack_public_path__ + "img/pay.24903e24.svg";